<iframe
  #frame
  [src]="src() | safe: 'resourceUrl'"
  frameborder="0"
  [style.height]="height()"
  [style.width]="width()"
  marginheight="0"
  [title]="title()"
  marginwidth="0"
  (load)="iframeLoaded()"
  class="inline-block"
></iframe>
@if ((debounceLoaded$ | async) !== true) {
  <div
    class="flex absolute left-0 top-0 justify-center items-center w-full h-full"
  >
    <mat-progress-spinner
      aria-progressbar-name="load iframe in progress"
      color="accent"
      mode="indeterminate"
    />
  </div>
}

@if (closeBtn()) {
  <button
    class="absolute top-0 right-0 flex items-center p-1 text-xs font-medium text-accent rounded-full border border-gray-200 hover:bg-gray-100 hover:text-accent/70 focus:z-10 focus:ring-2 focus:ring-gray-300"
    (click)="close.emit()"
    (mousedown)="preventFocus($event)"
  >
    <mat-icon>close</mat-icon>
  </button>
}
